const gbcourses = {
    FORMS: [],
    CSS: {
        id: '5e2f37cfdfa49aa290629466',
        name: 'gb-courses',
        avatar: {
          name: 'Gatblac Courses',
          header: 'https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/mTYKHq9je4S61654176336626.png',
          new: 'https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/mQTvG8oh8Wvv1654176307698.png',
          open: 'https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/xUZgX3A0DeQ21654176273495.png',
          close: 'https://gatblac.nyc3.digitaloceanspaces.com/QA/profiles/mTYKHq9je4S61654176336626.png'
        },
        style: {
          score: {
            inactiveColor: '#fff',
            activeColor: '#63DCDD',
            borderColor: '#63DCDD'
          }
        }
    }
  }
  
  export default gbcourses
  